/* eslint-disable import/no-mutable-exports */
import * as firebase from 'firebase/app';
import 'firebase/messaging';

function parseFirebaseConfig(rawConfig) {
  if (!rawConfig) {
    return null;
  }

  try {
    return JSON.parse(rawConfig);
  } catch (error) {
    // Local development can run without Firebase env vars.
    return null;
  }
}

const firebaseConfig = parseFirebaseConfig(process.env.FIREBASE_CONFIG);

let messaging = null;

if (
  !process.platform &&
  firebaseConfig &&
  process.env.FIREBASE_PUBLIC_VAPID_KEY &&
  firebase?.messaging?.isSupported()
) {
  const initializedFirebaseApp = firebase.initializeApp(firebaseConfig);
  messaging = initializedFirebaseApp.messaging();
  messaging.usePublicVapidKey(process.env.FIREBASE_PUBLIC_VAPID_KEY);
}

const getToken = async () =>
  messaging?.requestPermission().then(() => {
    return messaging.getToken();
  });

export { messaging, getToken };
